<template>
  <section v-if="bundleList.length === 0 && showBundle" class="fou-promotion">
    <p class="fou-promotion__list__name">{{ $t('pages.dashboard.components.bundle.bundles_empty') }}</p>
    <div class="promotion-btn-link">
      <MdButton class="create-btn" @click="goToCreateBundlesPage()">
        {{ $t('pages.dashboard.components.bundle.new_bundle_create') }}
      </MdButton>
      <MdButton class="learnMore-btn" variant="ghost" @click="handleLearnMoreClick">
        <span class="promotionLearnMore">
          {{$t('pages.dashboard.components.bundle.learn_more') }}
        </span>
        <MdIconArrowLong class="learnMore-iocn" rotate="up-right" size="small"></MdIconArrowLong>
      </MdButton>
    </div>
  </section>
  <div
    v-if="bundleList.length > 0"
    data-qa-id="expiring_bundles"
    class="fou-promotion"
  >
    <div
      v-for="bundle in bundleList"
      :key="bundle.id"
      data-qa-id="bundle-list"
      class="fou-promotion__list"
      :class="{ 'bundle-disable': bundle.permission === 'read' }"
    >
      <span
        data-qa-id="bundle-title"
        class="fou-promotion__list__name"
      >{{ bundle.name }}</span>
      <div class="fou-promotion__list__desc">
        <span class="fou-bundle__expiration-date">{{
          $t('pages.dashboard.components.bundle.readable_end_date', {
            endDate: calculateDaysLeft(bundle.deReleaseDate)
          })
        }}</span>
        <edit-icon
          v-if="bundle.permission === 'all'"
          data-qa-id="single-bundle-navigation"
          class="bundle-arrow"
          @click="goToBundlesPage(BUNDLE_SUBMISSION_DRAFT, bundle.id)"
        />
      </div>
    </div>
    <div class="footer-section">
      <MdButton data-qa-id="create-bundle-navigation" class="create-btn" @click="goToCreateBundlesPage()">
        <BundleIcon class="bundle-icon"/>
        {{ $t('pages.dashboard.components.bundle.new_bundle_create') }}
      </MdButton>
      <MdButton data-qa-id="all-bundle-navigation" class="all-bundles" variant="ghost"  @click="goToBundlesPage(BUNDLE_DASHBOARD, '')">
        {{ $t('pages.dashboard.components.bundle.all_bundle') }}
        <link-arrow class="ml-11" fill-color="#1A73E8"/>
      </MdButton>
    </div>
  </div>
  <div class="dashboard-bundle-spinner" v-if="!showBundle">
    <animation-processing fill="new-blue" class="dashboard-page-spinner" />
  </div>
</template>

<script src="./script.js"></script>

<style scoped>
  .learnMore-btn, .create-btn, .all-bundles {
    margin-top: 24px;
  }
  .promotionLearnMore {
    font-size: 13px;
    line-height: 16px;
    color: #1a73e8;
    font-family: "Helvetica Now Text W05 Medium", Arial, "Helvetica Neue", Helvetica, sans-serif;
    font-weight: 500;
  }
  .all-bundles::part(md-button) {
  font-size: 13px;
  line-height: 16px;
  cursor: pointer;
  font-family: "Helvetica Now Text W05 Medium", Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-weight: 500;
  }
  .learnMore-iocn {
    margin-left: 4px;
  }
  .footer-section { 
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
  @media (max-width: 719px) {
  .create-btn {
    width: 100%;
  }
  .learnMore-btn {
    margin-top: 0;
  }
  .footer-section {
    display: flex;
    flex-direction: column;
    }
  }

</style>